import { Tooltip } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { InfoOutlined } from '@material-ui/icons'
import { ReactNode } from 'react'

const useCustomStyle = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
    padding: '15px 15px 1px 15px',
    fontSize: 12,
  },
}))

interface Props {
  title: NonNullable<ReactNode>
}

const HelpTooltip = ({ title, ...props }: Props) => {
  const classes = useCustomStyle()

  return (
    <Tooltip
      title={title}
      placement="right-end"
      arrow
      classes={classes}
      {...props}
    >
      <InfoOutlined style={{ fontSize: 12 }} className="m-l-5" />
    </Tooltip>
  )
}
export default HelpTooltip
